import { render } from "./newsPage.vue?vue&type=template&id=30540d56"
import script from "./newsPage.vue?vue&type=script&lang=js"
export * from "./newsPage.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./newsPage.vue?vue&type=custom&index=0&blockType=srtyle&scoped=true"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__